module.exports = __webpack_public_path__ + "img/netflix-logo.daf22e26.svg";